import React from "react";
import PropTypes from "prop-types";
import {Button, Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import Objects from "../../../utils/Objects";

class PointForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {entity: props.defaultValue, setValue: props.setValue, index: props.index};
  }

  newState(props) {
    this.setState({entity: props.defaultValue, setValue: props.setValue, index: props.index});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue || nextProps.index !== this.props.index) {
      this.newState(nextProps);
    }
  }

  setValue(event) {
    const {setValue, index} = this.state;
    event.preventDefault();
    const x = this.pointX.value;
    const y = this.pointY.value;
    if (Objects.isNullOrUndefined(index)) {
      this.pointY.value = '';
      this.pointX.value = '';
    }
    setValue && setValue({x, y});
  }

  render() {
    const {entity = {}} = this.state;

    return (

        <Row>

          <Col lg={5}>
            <FormGroup>
              <ControlLabel>Ponto X</ControlLabel>
              <input type="number" min="0" className="form-control" placeholder="Ponto X"
                     name="pointX"
                     ref={
                       pointX => this.pointX = pointX
                     }
                     defaultValue={entity.x}
              />
            </FormGroup>
          </Col>

          <Col lg={5}>
            <FormGroup>
              <ControlLabel>Ponto Y</ControlLabel>
              <input type="number" min="0" className="form-control" placeholder="Ponto Y"
                     name="pointY"
                     ref={
                       pointY => this.pointY = pointY
                     }
                     defaultValue={entity.y}
              />
            </FormGroup>
          </Col>

          <Col lg={2}>
            <ControlLabel>&nbsp;</ControlLabel>
            <Button bsStyle="primary" className="pull-right form-control" onClick={event => this.setValue(event)}>
              Salvar
            </Button>
          </Col>
        </Row>
    );
  }
}

PointForm.propTypes = {
  setValue: PropTypes.func.isRequired,
  defaultValue: PropTypes.object,
  index: PropTypes.number

};

export default PointForm;



// WEBPACK FOOTER //
// ./src/map/polygon/point/PointForm.js